const SEO_LINKS_ASSETS_BASE_URL =
  'https://static.cdn-cian.ru/frontend/mortgage-assets/mortgage_promo_frontend/seo-links';

const getSeoLinkImageUrl = (filename: string) => `${SEO_LINKS_ASSETS_BASE_URL}/${filename}`;

export const seoLinkImages = {
  calc: {
    light: getSeoLinkImageUrl('calc_light.webp'),
    dark: getSeoLinkImageUrl('calc_dark.webp'),
  },
  pony: {
    light: getSeoLinkImageUrl('pony_light.webp'),
    dark: getSeoLinkImageUrl('pony_dark.webp'),
  },
  house: {
    light: getSeoLinkImageUrl('house_light.webp'),
    dark: getSeoLinkImageUrl('house_dark.webp'),
  },
  discount: {
    light: getSeoLinkImageUrl('discount_light.webp'),
    dark: getSeoLinkImageUrl('discount_dark.webp'),
  },
} as const;
